import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Retrieves a rendering of the requested {@link ents.core.mosaic.Action}
     */
    render: store.actions.request({
      input: store.actions.Data.asIs<{
        /**
         * Always required as this determines where the results are stored in
         * the state
         */
        identifier: ec.models.EntityId
        query: ents.core.mosaic.Action.Query
        variables?: ents.core.dms.data.query.Variable.Lookup
      }>(),
      output: store.actions.Data.asIs<{
        identifier: ec.models.EntityId
        rawRendering: unknown
      }>(),
      reducersDeprecated: {
        success: (state, { response: { identifier, rawRendering } }) => {
          state = { ...state }

          const entry = (state.actionRenderingLookup[identifier] ??= {})
          entry.rawRendering = rawRendering
          // NOTE: we might as well at least try and see if it works
          entry.rendering = rawRendering as ents.core.mosaic.Action.Rendering

          return state
        },
      },
    }),
    /**
     * Retrieves a rendering of the requested {@link ents.core.mosaic.Action}
     */
    test: store.actions.request({
      input: store.actions.Data.asIs<{
        /**
         * TODO: this is not stored in the state, so the below is not true
         *
         * Always required as this determines where the results are stored in
         * the state
         */
        identifier: ec.models.EntityId
        rendering?: ents.core.mosaic.Action.Rendering
      }>(),
      output: store.actions.Data.asIs<{
        identifier: ec.models.EntityId
        uiActionRenderings: readonly ents.core.mosaic.Action.Rendering.OfUiOperationsOnly[]
      }>(),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
